import script from "./ProcesoAutoevaluacionView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProcesoAutoevaluacionView.vue?vue&type=script&lang=ts&setup=true"

import "./ProcesoAutoevaluacionView.vue?vue&type=style&index=0&id=e9f39910&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9f39910"]])

export default __exports__